/**
 * Lush Scents — Featured Upsell Card ("Upsell Card (New Design)")
 * File: assets/lush-upsell-featured.js
 *
 * Why this file exists
 * --------------------
 * These functions previously lived in an inline <script> inside
 * snippets/cart-upsell-featured.liquid. That snippet renders inside the
 * cart-drawer section, and the drawer is re-rendered via the Section
 * Rendering API using innerHTML — and browsers NEVER execute <script>
 * tags injected via innerHTML. So if the page loaded with an empty cart
 * (the normal case), the functions were never registered, and the card's
 * onclick="lushUpsellAdd(this)" threw "lushUpsellAdd is not defined" —
 * the Add button silently did nothing.
 *
 * Moving the JS here guarantees it loads once, on every page, regardless
 * of cart state or how many times the drawer re-renders.
 *
 * Install
 * -------
 * Loaded from layout/theme.liquid with defer, AFTER lush-cart-gateway.js:
 *   <script src="{{ 'lush-upsell-featured.js' | asset_url }}" defer="defer"></script>
 */
(function () {
  'use strict';

  function lushUpsellCurrency() {
    var meta = document.querySelector('meta[name="currency"]');
    if (meta && meta.content) return meta.content;
    if (window.Shopify && Shopify.currency && Shopify.currency.active) return Shopify.currency.active;
    return 'USD';
  }

  if (typeof window.lushFormatMoney !== 'function') {
    window.lushFormatMoney = function (cents, currency) {
      var amount = cents / 100;
      if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
        return Shopify.formatMoney(cents, Shopify.money_format || '{{amount}}');
      }
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: currency || lushUpsellCurrency() }).format(amount);
    };
  }

  window.lushUpsellVariantChange = function (selectEl) {
    var form = selectEl.closest('form.lush-upsell-form');
    if (!form) return;
    var jsonEl = form.querySelector('script[type="application/json"]');
    if (!jsonEl) return;

    try {
      var product = JSON.parse(jsonEl.textContent);
      var selects = form.querySelectorAll('select[name^="options["]');
      var selected = Array.prototype.map.call(selects, function (s) {
        return s.value;
      });
      var variant = product.variants.find(function (v) {
        return selected.every(function (opt, i) {
          return v.options[i] === opt;
        });
      });

      if (variant) {
        var hidden = form.querySelector('input[name="id"]');
        if (hidden) hidden.value = variant.id;

        if (variant.price != null) {
          var currency = lushUpsellCurrency();
          var discountPercent = parseFloat(form.dataset.discountPercent) || 0;
          var discountFixedCents = parseFloat(form.dataset.discountFixedCents) || 0;
          var tierPriceCents = parseFloat(form.dataset.tierPriceCents) || 0;
          var salePrice = variant.price;

          if (tierPriceCents > 0) {
            salePrice = tierPriceCents;
          } else if (discountFixedCents > 0) {
            salePrice = Math.max(0, variant.price - discountFixedCents);
          } else if (discountPercent > 0) {
            salePrice = Math.round((variant.price * (100 - discountPercent)) / 100);
          }

          var comparePrice = variant.price;
          if (variant.compare_at_price && variant.compare_at_price > comparePrice) {
            comparePrice = variant.compare_at_price;
          }
          var hasDiscount = comparePrice > salePrice;

          var formatted = window.lushFormatMoney(salePrice, currency);
          var card = form.closest('.lush-upsell-card');
          if (card) {
            card.querySelectorAll('.lush-upsell-sale').forEach(function (el) {
              el.textContent = formatted;

              var priceRow = el.closest('.lush-upsell-price');
              var compareEl = priceRow ? priceRow.querySelector('.lush-upsell-compare') : null;

              if (hasDiscount) {
                var compareFormatted = window.lushFormatMoney(comparePrice, currency);
                if (!compareEl && priceRow) {
                  compareEl = document.createElement('s');
                  compareEl.className = 'lush-upsell-compare';
                  priceRow.insertBefore(compareEl, el);
                }
                if (compareEl) compareEl.textContent = compareFormatted;
              } else if (compareEl) {
                compareEl.remove();
              }
            });
          }
        }

        var img = form.querySelector('img');
        if (img && variant.featured_image && variant.featured_image.src) {
          var newSrc = variant.featured_image.src.replace(/^\/\//, 'https://').split('?')[0] + '?width=240';
          if (newSrc !== img.src) img.src = newSrc;
        }
      }

      selects.forEach(function (sel, idx) {
        Array.prototype.forEach.call(sel.options, function (opt) {
          var test = selected.slice();
          test[idx] = opt.value;
          opt.disabled = !product.variants.some(function (v) {
            return test.every(function (val, i) {
              return v.options[i] === val;
            });
          });
        });
      });
    } catch (err) {
      console.error('lushUpsellVariantChange error:', err);
    }
  };

  // Serialise upsell adds so rapid taps don't flood Shopify's cart API (HTTP 429).
  window.__lushUpsellQueue = window.__lushUpsellQueue || Promise.resolve();

  window.lushUpsellAdd = function (buttonEl) {
    var form = buttonEl.closest('form.lush-upsell-form');
    if (!form) return;
    var idInput = form.querySelector('input[name="id"]');
    var variantId = idInput ? idInput.value : null;
    if (!variantId) return;
    if (buttonEl.disabled) return;

    var originalHTML = buttonEl.innerHTML;
    buttonEl.disabled = true;
    buttonEl.classList.add('is-loading');
    buttonEl.innerHTML = '<span class="lush-spinner"></span>';

    var addUrl = window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add.js';
    var payload = {
      id: variantId,
      quantity: 1,
      sections: 'cart-drawer,cart-icon-bubble',
      sections_url: window.location.pathname
    };

    function restore(delay) {
      setTimeout(function () {
        buttonEl.innerHTML = originalHTML;
        buttonEl.style.fontSize = '';
        buttonEl.style.whiteSpace = '';
        buttonEl.style.lineHeight = '';
        buttonEl.disabled = false;
      }, delay);
    }

    function showError(message) {
      console.error('lushUpsellAdd error:', message);
      buttonEl.classList.remove('is-loading');
      buttonEl.innerHTML = '\u2717 ' + (message || 'Error');
      buttonEl.style.fontSize = '10px';
      buttonEl.style.whiteSpace = 'normal';
      buttonEl.style.lineHeight = '1.15';
      restore(4000);
    }

    function sleep(ms) {
      return new Promise(function (res) {
        setTimeout(res, ms);
      });
    }

    // POST once; on 429 wait (Retry-After or 1.5s) and retry once more.
    // (The cart gateway also retries 429s, so this is belt-and-braces.)
    function postAdd(attempt) {
      return fetch(addUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          Accept: 'application/json'
        },
        body: JSON.stringify(payload)
      }).then(function (response) {
        if (response.status === 429 && attempt < 1) {
          var retryAfter = parseFloat(response.headers.get('Retry-After')) || 1.5;
          console.warn('lushUpsellAdd: rate limited, retrying in ' + retryAfter + 's');
          return sleep(retryAfter * 1000).then(function () {
            return postAdd(attempt + 1);
          });
        }
        return response.text().then(function (text) {
          var data = null;
          try {
            data = JSON.parse(text);
          } catch (e) {}
          if (!response.ok) {
            var msg =
              (data && (data.description || data.message)) ||
              (response.status === 429 ? 'Too many requests, try again' : 'HTTP ' + response.status);
            console.error('lushUpsellAdd response:', response.status, data || text.slice(0, 500));
            throw new Error(msg);
          }
          if (!data) {
            console.error('lushUpsellAdd non-JSON response:', text.slice(0, 500));
            throw new Error('Unexpected response');
          }
          if (data.status) {
            throw new Error(data.description || data.message || 'Error adding product to cart');
          }
          return data;
        });
      });
    }

    var run = window.__lushUpsellQueue
      .then(function () {
        return postAdd(0);
      })
      .then(function (data) {
        var cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.renderContents === 'function' && data.sections) {
          try {
            cartDrawer.renderContents(data);
          } catch (renderErr) {
            console.error('lushUpsellAdd render error (item was added):', renderErr);
            if (typeof window.refreshCartDrawer === 'function') window.refreshCartDrawer();
          }
        } else if (typeof window.refreshCartDrawer === 'function') {
          window.refreshCartDrawer();
        }
        buttonEl.classList.remove('is-loading');
        buttonEl.innerHTML = '\u2713 Added!';
        restore(2000);
      })
      .catch(function (err) {
        showError(err && err.message ? err.message : 'Error');
      });

    window.__lushUpsellQueue = run.catch(function () {});
  };

  window.lushInitUpsellSwipers = function (root) {
    var scope = root || document;
    var els = scope.querySelectorAll('[data-lush-swiper]:not([data-lush-swiper-ready])');
    if (!els.length || typeof window.swiperCheckAndLoad !== 'function') return;

    window.swiperCheckAndLoad().then(function () {
      if (typeof window.Swiper !== 'function') return;
      els.forEach(function (el) {
        if (el.hasAttribute('data-lush-swiper-ready')) return;
        el.setAttribute('data-lush-swiper-ready', 'true');
        var instance = new window.Swiper(el, {
          slidesPerView: 1.15,
          centeredSlides: false,
          spaceBetween: 10,
          grabCursor: true,
          speed: 400,
          resistanceRatio: 0.85,
          watchSlidesProgress: true,
          observer: true,
          observeParents: true,
          observeSlideChildren: true,
          pagination: {
            el: el.querySelector('.swiper-pagination'),
            clickable: true
          }
        });

        // The cart drawer is hidden (zero width) when this initializes on page
        // load, so Swiper's first measurement is wrong and dragging feels like
        // it "jumps." Force a clean recalculation once the drawer actually opens.
        var cartDrawerEl = el.closest('cart-drawer');
        if (cartDrawerEl) {
          cartDrawerEl.addEventListener('cart-drawer:update', function () {
            instance.update();
          });
        }
        window.addEventListener('resize', function () {
          instance.update();
        });
      });
    });
  };

  function initAll() {
    window.lushInitUpsellSwipers();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('cart-drawer:render', function () {
    window.lushInitUpsellSwipers();
  });
  // The drawer dispatches this event on itself (it bubbles), so listening on
  // document catches every re-render — including the one right after an add.
  var drawerEl = document.querySelector('cart-drawer');
  if (drawerEl) {
    drawerEl.addEventListener('cart-drawer:render', function () {
      window.lushInitUpsellSwipers();
    });
  }
})();
